import React from 'react'

export default function Home() {
  return (
    <div className='thi'>
     <h1 className='pp'>404</h1>
     Page not Found
    </div>
  )
}
